var map = {
	"./menu-icon1-s.png": 16878,
	"./menu-icon2-s.png": 76036,
	"./menu-icon3-s.png": 32447,
	"./menu-icon4-s.png": 41694,
	"./menu-icon5-s.png": 68150,
	"./menu-icon6-s.png": 51822,
	"./menu-icon7-s.png": 93722
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20119;